<template>
  <el-drawer v-dialog-window :title="form.id ? '编辑司机' : '新增司机'" :visible.sync="drawerVisible" direction="rtl" size="420px" append-to-body>
    <div class="driver-drawer">
      <el-form ref="form" :model="form" :rules="rules" label-position="top">
        <el-form-item label="司机姓名" prop="driverName">
          <el-input v-model.trim="form.driverName" maxlength="64" placeholder="请输入司机姓名" />
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model.trim="form.phone" maxlength="11" placeholder="请输入11位手机号" />
        </el-form-item>
      </el-form>
      <div class="driver-drawer__tip">同一用户下，司机姓名和手机号组合不能重复。</div>
      <div class="driver-drawer__footer">
        <el-button @click="drawerVisible = false">取消</el-button>
        <el-button v-permission="form.id ? 'driver:edit' : 'driver:add'" type="primary" :loading="saving" @click="submit">保存</el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { isRequestSuccess, saveDriver, updateDriver } from './lingdongApi'

const createForm = () => ({ id: null, driverName: '', phone: '' })

export default {
  name: 'DriverFormDrawer',
  props: {
    visible: { type: Boolean, default: false },
    driver: { type: Object, default: null }
  },
  data() {
    return {
      drawerVisible: false,
      saving: false,
      form: createForm(),
      rules: {
        driverName: [{ required: true, message: '请输入司机姓名', trigger: 'blur' }],
        phone: [{ required: true, pattern: /^1\d{10}$/, message: '请输入正确的11位手机号', trigger: 'blur' }]
      }
    }
  },
  watch: {
    visible(value) {
      this.drawerVisible = value
      if (value) this.initForm()
    },
    drawerVisible(value) {
      this.$emit('update:visible', value)
    }
  },
  methods: {
    initForm() {
      this.form = this.driver ? { id: this.driver.id, driverName: this.driver.driverName || '', phone: this.driver.phone || '', enabled: this.driver.enabled, status: this.driver.status } : createForm()
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    async submit() {
      try {
        await this.$refs.form.validate()
      } catch (e) {
        return
      }
      this.saving = true
      try {
        const res = await (this.form.id ? updateDriver(this.form) : saveDriver(this.form))
        if (!isRequestSuccess(res)) throw new Error(res.msg || '保存失败')
        const driver = res.data || { ...this.form }
        this.$message.success('司机已保存')
        this.$emit('saved', driver)
        this.drawerVisible = false
      } catch (e) {
        this.$message.error(e.msg || e.message || '保存失败')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.driver-drawer { display: flex; min-height: calc(100vh - 54px); flex-direction: column; padding: 20px; box-sizing: border-box; }
::v-deep .dialog-window .driver-drawer { min-height: 100%; }
.driver-drawer__tip { color: #98a2b3; font-size: 13px; }
.driver-drawer__footer { display: flex; justify-content: flex-end; gap: 10px; margin-top: auto; padding-top: 20px; }
</style>
